import { render, staticRenderFns } from "./editBatch.vue?vue&type=template&id=853bdd88&scoped=true"
import script from "./editBatch.vue?vue&type=script&lang=js"
export * from "./editBatch.vue?vue&type=script&lang=js"
import style0 from "./editBatch.vue?vue&type=style&index=0&id=853bdd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853bdd88",
  null
  
)

export default component.exports